let modelsMappedByResource = {
  simulate_unit: () => require("@/models/TmsCatalde/simulateUnit"),
  tokens: () => require("@/models/token"),
  companies: () => require("@/models/company"),
  shippers: () => require("@/models/shipper"),
  customers: () => require("@/models/customer"),
  transporters: () => require("@/models/transporter"),
  risk_managers: () => require("@/models/riskManager"),
  addresses: () => require("@/models/address"),
  order_collection_addresses: () => require("@/models/orderCollectionAddress"),
  order_delivery_addresses: () => require("@/models/orderDeliveryAddress"),
  users: () => require("@/models/user"),
  orders: () => require("@/models/order"),
  status: () => require("@/models/status"),
  loan_quote_items: () => require("@/models/loanQuoteItem"),
  invoice: () => require("@/models/invoice"),
  simulation_orders: () => require("@/models/simulationOrders"),
  simulation_quotes_files: () => require("@/models/simulationQuotesFiles"),
  simulation_quotes_transporters: () => require("@/models/simulationQuotesTransporters"),
  messages_quotes: () => require("@/models/messagesQuotes"),
  risk_manager_orders: () => require("@/models/riskManagerOrder"),
  pgr_files: () => require("@/models/pgrFile"),
  nf_files: () => require("@/models/nfFile"),
  nf_pdf_files: () => require("@/models/nfPdfFile"),
  cte_files: () => require("@/models/cteFile"),
  vehicle_types: () => require("@/models/vehicleType"),
  vehicle_options: () => require("@/models/vehicleOption"),
  vehicle_type_modal: () => require("@/models/vehicleTypeModal"),
  drivers: () => require("@/models/driver"),
  helpers: () => require("@/models/helper"),
  oficio_files: () => require("@/models/oficioFile"),
  nf_service_files: () => require("@/models/nfServiceFile"),
  purchase_orders: () => require("@/models/purchaseOrder"),
  export_report: () => require("@/models/exportReport"),
  audits: () => require("@/models/audit"),
  canhoto_files: () => require("@/models/canhotoFile"),
  fintechs: () => require("@/models/fintech"),
  fatura_files: () => require("@/models/faturaFile"),
  quote_status: () => require("@/models/quoteStatus"),
  quote_contracts: () => require("@/models/quoteContract"),
  quote_proposals: () => require("@/models/quoteProposal"),
  additional_services: () => require("@/models/additionalService"),
  order_additional_services: () => require("@/models/orderAdditionalService"),
  order_additional_services_files: () => require("@/models/orderAdditionalServicesFiles"),
  quotations: () => require("@/models/quotation"),
  quotation_status: () => require("@/models/quotationStatus"),
  quotation_solicitations: () => require("@/models/quotationSolicitation"),
  quotation_documents: () => require("@/models/quotationDocument"),
  transporter_logs: () => require("@/models/transporterLog"),
  quotation_proposals: () => require("@/models/quotationProposal"),
  solicitation_status: () => require("@/models/solicitationStatus"),
  anticipations: () => require("@/models/anticipation"),
  faturas: () => require("@/models/fatura"),
  chat_rooms: () => require("@/models/chatRoom"),
  quotation_logs: () => require("@/models/quotationLog"),
  transporter_documents: () => require("@/models/transporterDocument"),
  proceda_occurrences: () => require("@/models/procedaOccurrence"),
  simulation_quotes: () => require("@/models/simulationQuotes"),
  icms: () => require("@/models/icms"),
  company_logo: () => require("@/models/companyLogo"),
  quotation_modalities: () => require("@/models/quotationModality"),
  nfes: () => require("@/models/nfe"),
  taker_additional_data: () => require("@/models/takerAdditionalData"),
  panel_notification: () => require("@/models/panelNotification"),
  file_view_path: () => require("@/models/fileViewPath"),
  audits_order: () => require("@/models/auditsOrder"),
  audits_order_additional_services: () => require("@/models/auditsOrderAdditionalService"),
  taker_bank_accounts: () => require("@/models/finance/takerBankAccount"),
  taker_final_beneficiaries: () => require("@/models/takerFinalBeneficiary"),
  actions: () => require("@/models/action"),
  transporter_code_actions: () => require("@/models/transporterCodeActions"),
  transporter_custom_occurrence: () => require("@/models/transporterCustomOccurrence"),
  quotation_invoices: () => require("@/models/finance/quotationInvoice"),
  quotation_nfes: () => require("@/models/finance/quotationNfe"),
  quotation_ctes: () => require("@/models/finance/quotationCte"),
  billings: () => require("@/models/billing"),
  simulation_tms: () => require("@/models/simulationTms"),
  billing_plan_values: () => require("@/models/billingPlanValue.js"),
  billing_extra_plan_values: () => require("@/models/billingExtraPlanValue.js"),
  company_extra_plan_values: () => require("@/models/companyExtraPlanValue.js"),
  extra_plans: () => require("@/models/extraPlan.js"),
  fintech_settings: () => require("@/models/finance/fintechSetting"),
  request: () => require("@/models/request"),
  road_maps: () => require("@/models/roadMap"),
  road_maps_requests: () => require("@/models/roadMapRequest"),
  transporter_drivers: () => require("@/models/transporterDriver"),
  geolocation_drivers: () => require("@/models/geolocationDriver"),
  request_files: () => require("@/models/requestFiles"),
  location: () => require("@/models/TmsCatalde/location"),
  route: () => require("@/models/TmsCatalde/route"),
  report_values_target_state: () => require("@/models/reportValuesByTargetState"),
  simulation_orders_addresses: () => require("@/models/simulationOrdersAddresses"),
  simulation_integra_orders_addresses: () => require("@/models/simulationIntegraOrdersAddresses"),
  notfis_files: () => require("@/models/notfisFile"),
  transporter_configurations: () => require("@/models/transporterConfiguration"),
  proceda_custom_occurrences: () => require("@/models/procedaCustomOccurrence"),
  simulation_tables: () => require("@/models/simulationTable"),
  simulation_table_prolongation: () => require("@/models/simulationTableProlongation"),
  simulation_advalorem: () => require("@/models/simulationAdvalorem"),
  simulation_gris: () => require("@/models/simulationGris"),
  simulation_km_ranges: () => require("@/models/simulationKmRange"),
  simulation_values: () => require("@/models/simulationValue"),
  simulation_values_add: () => require("@/models/simulationValueAdd"),
  simulation_kg_ranges: () => require("@/models/simulationKgRange"),
  simulation_kg_values: () => require("@/models/simulationKgValue"),
  simulation_destinations: () => require("@/models/simulationDestination"),
  transporter_tde: () => require("@/models/transporterTde"),
  transporter_trt: () => require("@/models/transporterTrt"),
  simulation_table_tde: () => require("@/models/simulationTableTde"),
  simulation_table_trt: () => require("@/models/simulationTableTrt"),
  simulation_table_tda: () => require("@/models/simulationTableTda"),
  simulation_tables_files: () => require("@/models/simulationTableFile"),
  simulation_integra_orders: () => require("@/models/simulationIntegraOrders"),
  simulation_table_suframa: () => require("@/models/simulationTableSuframa"),
  simulation_table_river_insurance: () => require("@/models/simulationTableRiverInsurance"),
  simulation_table_tub: () => require("@/models/simulationTableTub"),
  simulation_table_additional_services: () => require("@/models/simulationTableAdditionalService"),
  states: () => require("@/models/state"),
  billing_contracted_prices: () => require("@/models/billingContractedPrice"),
  billing_contracted_price_additionals: () => require("@/models/billingContractedPriceAdditional"),
  cities: () => require("@/models/city"),
  notifications: () => require("@/models/notification"),
  suppliers: () => require("@/models/supplier"),
  romaneio_files: () => require("@/models/romaneioFile"),
  route_tables: () => require("@/models/routeTable"),
  route_tables_rates: () => require("@/models/routeTableRate"),
  route_tables_files: () => require("@/models/routeTableFile"),
  shipper_table_model: () => require("@/models/shipperTableModel"),
  route_table_order: () => require("@/models/routeTableOrder"),
  company_custom_settings: () => require("@/models/companyCustomSetting"),
  user_follow_order: () => require("@/models/userFollowOrder"),
  simulation_quotes_addresses: () => require("@/models/simulationQuoteAddress"),
  simulation_quotes_transporters_addresses: () => require("@/models/simulationQuoteTransporterAddress"),
  request_simulations: () => require("@/models/requestSimulation"),
  request_client_other_transporter: () => require("@/models/requestClientOtherTransporter"),
  request_simulation_refusal_justification: () => require("@/models/requestSimulationRefusalJustification"),
  configurations_audit: () => require("@/models/configurationsAudit"),
  transporter_cte_reading_emails: () => require("@/models/transporterCteReadingEmail"),
  cte_reading_emails: () => require("@/models/cteReadingEmail"),
  company_features: () => require("@/models/companyFeatures"),
  correios_modals_transport: () => require("@/models/correiosModalTransport"),
  products: () => require("@/models/product"),
  request_invoices: () => require("@/models/requestInvoice"),
  fob_orders: () => require("@/models/fobOrder"),
  fob_order_nf_files: () => require("@/models/fobOrderNfFile"),
  fob_order_occurrences: () => require("@/models/fobOrderOccurrence"),
  order_invoices: () => require("@/models/orderInvoice"),
  request_products: () => require("@/models/requestProduct"),
  order_integration_tasks: () => require("@/models/orderIntegrationTask"),
  shipper_occurrences: () => require("@/models/shipperOccurrence"),
  transporter_credentials: () => require("@/models/transporterCredential"),
  chatbot_allowed_numbers: () => require("@/models/chatbotAllowedNumber"),
};

export default modelsMappedByResource;
